module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/promise_09_sp-f5e76f057472ceaa885301032bf2b043.png";